import createReducer from '../utils/createReducer';
import actions from '../actions/confirmationPage';
import {MERCHANT_OF_RECORD, ROLLOUT_STRATEGY} from "../utils/constants";

const initialState = {};

const actionHandlers = {
    [actions.SET_BUSINESS_MODEL_SWITCH_CHOICE](state, { payload }) {
        const advertiserBusinessModel = payload.advertiserBusinessModel;
        const rolloutStrategy = payload.rolloutStrategy;
        const preferredBusinessModel = payload.preferredBusinessModel;
        const currency = payload.currency;
        const rowMorEnabled = payload.rowMorEnabled;

        // PMIS advertisers already on EG with an EG-preferred config are still allowed
        // to enter the business model switch flow while their EG rollout is gradual.
        const isGradualEgRollout = advertiserBusinessModel === MERCHANT_OF_RECORD.EG
            && preferredBusinessModel === MERCHANT_OF_RECORD.EG
            && rolloutStrategy === ROLLOUT_STRATEGY.GRADUAL;

        return {
            ...state,
            showBusinessModelSwitch: isGradualEgRollout
                || (advertiserBusinessModel === MERCHANT_OF_RECORD.SUPPLIER
                    && preferredBusinessModel !== MERCHANT_OF_RECORD.SUPPLIER
                    && (rowMorEnabled || currency === 'USD'))
        };
    },
};

export default createReducer(actionHandlers, initialState);
